<template>
  <div id="team" >
    <div class="row team-title mb-5 ">
      <div class="col-12 d-flex justify-content-center align-items-center">
        <h1 >{{$t('teamTitleText')}}</h1>
        <img
          src="../assets/team.png"
          alt="Zingal Son Kuşak"
          class="team-header"
        />
      </div>
    </div>
    <div class="row ">
      <div
        class="col-md-4 col-lg-3 col-sm-6 mb-3"
        v-for="(member, i) in teamMembers"
        :key="i"
      >
        <div class="cards">
          <div class="imgbox">
            <img
              :src="require('@/assets/team/' + member.img)"
              :alt="member.name"
              style="filter:grayscale(0.6)"
            />
          </div>
          <div class="content">
            <h2>{{ member.name }}</h2>
            <h5>{{ member.job }}</h5>
            <hr />
            <div class="mt-3">
              <a target="_blank" :href="member.facebook"
                ><i class="fab fa-facebook"></i
              ></a>
              <a target="_blank" :href="member.instagram"
                ><i class="fab fa-instagram"></i
              ></a>
              <a target="_blank" :href="member.twitter"
                ><i class="fab fa-twitter"></i
              ></a>
              <a target="_blank" :href="member.youtube"
                ><i class="fab fa-youtube"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
     
      teamMembers: [
        {
          img: "izzet.png",
          name: "İzzet ARSLAN",
          job: "DIRECTOR / PRODUCER",
          facebook: "https://www.facebook.com/izzet.arslan.96",
          instagram: "https://www.instagram.com/arslanizzet/",
          twitter: "#",
          youtube: "https://www.youtube.com/channel/UCexBy2EHpPhY9BDYkh3e-5Q"
        },
        {
          img: "seda.png",
          name: "Seda TANUS",
          job: "ASSISTANT DIRECTOR",
          facebook: "#",
          instagram: "#",
          twitter:"#",
          youtube:"#"
        },
        {
          img: "mustafa.jpg",
          name: "Mustafa DEMİRTAŞ",
          job: "CINEMATOGRAPHER",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        },
        {
          img: "kaan.jpg",
          name: "Burak Kaan SOYLU",
          job: "DRONE OPERATOR",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        },
        {
          img: "enes.jpg",
          name: "Enes ÇETİNKAYA",
          job: "SOUND",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        },
        {
          img: "orkhan.jpg",
          name: "Orkhan MİRZESOY",
          job: "MUSIC",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        },
        {
          img: "mehtap.jpg",
          name: "Mehtap TEMİZ",
          job: "ARCHIVE",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        },
        {
          img: "cigdem.jpg",
          name: "Çiğdem YILMAZ",
          job: "ARCHIVE",
          facebook: "",
          instagram: "",
          twitter: "",
          youtube: ""
        }
      ]
    };
  }
};
</script>

<style scoped>
* {
  font-family: "Quicksand", sans-serif;
}
h1 {
  font-size: 45px !important;
  color: white;
  font-family: 'Sansita Swashed', cursive;
  
}
h2 {
  font-size: 30px !important;
  color: #333;
}
h5 {
  font-size: 20px !important;
  color: #555;
}
a {
  color: #333;
  margin-right: 10px;
  margin-left: 10px;
}
a > i {
  font-size: 30px;
  transform: rotate(0);
  transition: all 1s ease-in-out;
}
a:hover > i {
  transition: all 1s ease-in-out;
  transform: rotate(360deg);
}
.team-title {
  height: 250px;
}
.team-header {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  height: 250px;
  width: 100%;
  object-fit: cover;
  filter: grayscale(0.7);
}

.cards {
  position: relative;
  max-width: 100%;
  max-height: 260px;
  background: white;
  margin: 30px 15px;
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 35px rgba(0, 0, 0, 0.5);
  transition: 0.3s ease-in-out;
}
.cards:hover {
  max-height: 500px;
}
.cards .imgbox {
  position: relative;
  max-width: 240px;
  height: 240px;
  top: -60px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}
.cards .imgbox img {
  max-width: 100%;
  border-radius: 4px;
}

.cards .content {
  position: relative;
  text-align: center;
  margin-top: -140px;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s ease-in-out;
  color: #111;
}
.cards:hover .content {
  margin-top: -40px;
  visibility: visible;
  opacity: 1;
}

@media screen and (max-height: 390px) {
  .cards .content {
    position: relative;
    text-align: center;
    margin-top: -40px;
    visibility: visible;
    opacity: 1;
    transition: 0.5s ease-in-out;
    color: #111;
  }
}
</style>
